type AssertIsNotNil = <T>(value: T, message?: string) => asserts value is NonNullable<T>;

const assertIsNotNil: AssertIsNotNil = <T>(value: T, message?: string): asserts value is NonNullable<T> => {
  if (value === undefined || value === null) {
    throw new Error(message || `Expected ${value} to be not null or undefined`);
  }
};

export default assertIsNotNil;
